import axios from "axios";

const API_URL = `${global.api_url}/auth/v1/api/token`;

class AuthService {

  setWithExpiry(key:any, value:any, ttl:any) {
    const now = new Date()
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  login(username: string, password: string) {
    return axios
      .post(API_URL, {}, {
        auth: {
          username,
          password
        }
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem("username", username.split('@')[0]);
          localStorage.setItem("user", JSON.stringify(response.data.token));
          return response.data.token;
        }
      });
  }
}

export default new AuthService();